var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorymakers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9597 11.6C13.5037 11.6 14.7597 10.344 14.7597 8.79999C14.7597 7.256 13.5037 6 11.9597 6C10.4157 6 9.15971 7.256 9.15971 8.79999C9.15971 10.344 10.4157 11.6 11.9597 11.6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5596 13.2C18.6628 13.2 19.5596 12.3024 19.5596 11.2C19.5596 10.0976 18.6628 9.19997 17.5596 9.19997C16.4564 9.19997 15.5596 10.0976 15.5596 11.2C15.5596 12.3024 16.4564 13.2 17.5596 13.2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36037 13.2C7.46277 13.2 8.36036 12.3024 8.36036 11.2C8.36036 10.0976 7.46277 9.19997 6.36037 9.19997C5.25797 9.19997 4.36037 10.0976 4.36037 11.2C4.36037 12.3024 5.25797 13.2 6.36037 13.2Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.96 12.3999C9.09283 12.3999 6.76004 14.7327 6.76004 17.5999C6.76004 17.8207 6.93924 17.9999 7.16004 17.9999H16.76C16.9808 17.9999 17.16 17.8207 17.16 17.5999C17.16 14.7327 14.8272 12.3999 11.96 12.3999Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75976 14.0865C6.53447 14.0345 6.3055 14.0001 6.07285 14.0001C4.2455 14.0001 2.75977 15.6153 2.75977 17.6001C2.75977 17.8209 2.92395 18.0001 3.12789 18.0001H5.77246C5.73123 17.8745 5.70473 17.7409 5.70473 17.6001C5.70473 16.2873 6.09935 15.0753 6.75976 14.0865Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8459 14.0001C17.6133 14.0001 17.3843 14.0345 17.159 14.0865C17.8194 15.0753 18.214 16.2873 18.214 17.6001C18.214 17.7409 18.1875 17.8745 18.1463 18.0001H20.7909C20.9941 18.0001 21.159 17.8209 21.159 17.6001C21.159 15.6153 19.6725 14.0001 17.8459 14.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorymakers);
export default __webpack_public_path__ + "static/media/storymakers.ce4fb6a8c717cb39ee97ab45ee3e446c.svg";
export { ForwardRef as ReactComponent };